var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.415-.307c-138.071 0-250 111.929-250 250s111.929 250 250 250 250-111.928 250-250-111.929-250-250-250zM405.436 135.3c-2.192 7.674-48.659 49.047-71.678 79.74-23.02 30.693-54.982 82.656-73.429 125.794-13.305 31.114-13.839 35.352-28.089 43.025-14.251 7.673-41.655 13.154-47.136 8.77-5.482-4.385-13.277-24.551-34.104-59.629-20.827-35.078-29.312-41.81-53.479-58.542-11.148-7.718 21.376-26.582 40.011-29.871 18.635-3.289 34.805 7.851 50.152 24.294 15.347 16.443 26.057 38.793 31.538 39.89 5.481 1.096 16.49-36.384 47.47-80.788 27.885-39.969 74.069-90.764 95.993-97.341 21.923-6.579 44.943-3.015 42.751 4.658z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.97c6c49a42450d5ccc996e680b27e40c.svg";
export { ForwardRef as ReactComponent };